<template>
   <section class="trusted">
      <div class="trusted__wrap center">
         <h2 class="trusted__title">
            Trusted by developers from the world&rsquo;s leading companies
         </h2>

         <div class="marquee">
            <div class="marquee__track">
               <ul class="marquee__row">
                  <li v-for="name in companies" :key="name">{{ name }}</li>
               </ul>
               <ul class="marquee__row" aria-hidden="true">
                  <li v-for="name in companies" :key="`dup-${name}`">{{ name }}</li>
               </ul>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
const COMPANIES = [
   'Google',
   'Microsoft',
   'IBM',
   'ORACLE',
   'Adobe',
   'facebook',
   'intel',
   'Cisco',
   'LinkedIn',
   'Deloitte',
   'Philips',
   'Walmart',
];

export default {
   name: 'CustomersHome',
   data() {
      return {
         companies: COMPANIES,
      };
   },
};
</script>

<style lang="scss" scoped>
.trusted {
   background: #f6f7fb;
   border-bottom: 1px solid #d8dce6;
   padding: 34px 0 36px;
   overflow: hidden;

   &__wrap {
      // Matches the site's shared .container-1440 width so this section's
      // content lines up with the hero and other sections above/below it,
      // rather than the reference's own full-bleed edge-to-edge marquee.
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 24px;
   }
   &__title {
      font-size: 17px;
      font-weight: 600;
      color: #3c415c;
      letter-spacing: 0;
      margin: 0;
   }
}
.center {
   text-align: center;
}

.marquee {
   position: relative;
   margin-top: 26px;
   overflow: hidden;
   -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 14%, #000 86%, transparent 100%);
   mask-image: linear-gradient(90deg, transparent 0, #000 14%, #000 86%, transparent 100%);

   &__track {
      display: flex;
      width: max-content;
      animation: fc-marquee 46s linear infinite;
   }
   &:hover &__track {
      animation-play-state: paused;
   }
   &__row {
      display: flex;
      align-items: center;
      gap: 96px;
      padding-right: 96px;
      list-style: none;
      margin: 0;

      li {
         font-size: 23px;
         font-weight: 800;
         letter-spacing: -0.025em;
         white-space: nowrap;
         color: #2f3345;
         opacity: 0.72;
         transition: opacity 0.2s ease;
         font-family: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, Helvetica, Arial,
            sans-serif;

         &:hover {
            opacity: 1;
         }
      }
   }
}

@keyframes fc-marquee {
   from {
      transform: translateX(0);
   }
   to {
      transform: translateX(-50%);
   }
}
@media (max-width: 760px) {
   .trusted {
      padding: 26px 0 28px;
      &__title {
         font-size: 15.5px;
      }
   }
   .marquee {
      margin-top: 20px;
      &__row {
         gap: 56px;
         padding-right: 56px;

         li {
            font-size: 19px;
         }
      }
   }
}
</style>
